import React from 'react';

function StatBox({ icon, label, value }) {
  if (!value) return null;
  return (
    <div style={{
      flex: 1, minWidth: 0, textAlign: 'center',
      padding: '8px 6px', background: 'rgba(255,255,255,0.03)',
      border: '1px solid rgba(255,255,255,0.06)', borderRadius: 8,
    }}>
      <div style={{ fontSize: 14, marginBottom: 2 }}>{icon}</div>
      <div style={{ fontSize: 11.5, color: 'rgba(220,228,255,0.85)', fontWeight: 600 }}>{value}</div>
      <div style={{ fontSize: 8.5, color: 'rgba(107,122,170,0.7)', textTransform: 'uppercase', letterSpacing: '.04em', marginTop: 1 }}>{label}</div>
    </div>
  );
}

export function RecipeCard({ name = 'Receita', time, portions, ingredients = [], steps = [], tip }) {
  return (
    <div style={{ margin: '10px 0 14px', padding: '14px 16px', background: 'rgba(6,14,40,0.55)', border: '1px solid rgba(56,189,248,0.12)', borderRadius: 12, fontFamily: 'inherit' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 12 }}>
        <span style={{ fontSize: 18, lineHeight: 1 }}>🍽</span>
        <span style={{ fontSize: 14.5, fontWeight: 700, color: '#f0f4ff', letterSpacing: '.01em' }}>{name}</span>
      </div>

      {(time || portions) && (
        <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
          <StatBox icon="⏱" label="Tempo" value={time} />
          <StatBox icon="🍽" label="Porções" value={portions} />
        </div>
      )}

      {ingredients.length > 0 && (
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 9.5, letterSpacing: '.08em', textTransform: 'uppercase', color: 'rgba(56,189,248,0.55)', marginBottom: 7 }}>
            🛒 Ingredientes
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
            {ingredients.map((ing, i) => (
              <div key={i} style={{ display: 'flex', gap: 8, fontSize: 12.5, color: 'rgba(220,228,255,0.78)', lineHeight: 1.45 }}>
                <span style={{ color: '#38bdf8', flexShrink: 0 }}>•</span>{ing}
              </div>
            ))}
          </div>
        </div>
      )}

      {steps.length > 0 && (
        <div style={{ marginBottom: tip ? 12 : 0 }}>
          <div style={{ fontSize: 9.5, letterSpacing: '.08em', textTransform: 'uppercase', color: 'rgba(56,189,248,0.55)', marginBottom: 7 }}>
            👨‍🍳 Modo de Preparo
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {steps.map((s, i) => (
              <div key={i} style={{ display: 'flex', gap: 9, fontSize: 12.5, color: 'rgba(220,228,255,0.78)', lineHeight: 1.48 }}>
                <span style={{
                  flexShrink: 0, width: 16, height: 16, marginTop: 1, borderRadius: '50%',
                  background: 'rgba(56,189,248,0.15)', color: '#38bdf8', fontSize: 9.5, fontWeight: 700,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>{i + 1}</span>
                {s}
              </div>
            ))}
          </div>
        </div>
      )}

      {tip && (
        <div style={{
          borderTop: '1px solid rgba(56,189,248,0.1)', paddingTop: 10,
          display: 'flex', gap: 8, fontSize: 12, color: 'rgba(172,196,236,0.8)', lineHeight: 1.45,
        }}>
          <span style={{ flexShrink: 0 }}>💡</span>{tip}
        </div>
      )}
    </div>
  );
}
